import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import deletes from "../../Assets/Image/admin/delete.png";
import { Pencil } from 'lucide-react';
import Dialog from '../../Base-Component/Dialog/Dialog';
import { FaCaretUp, FaSort, FaSortDown } from 'react-icons/fa';
import { useDebounce } from 'use-debounce';
import { addExcercise, allExcerciseList, deleteExcercise, editExcercise } from '../../Services/ApiServices';
import toast from 'react-hot-toast';
import nodata from "../../Assets/Image/admin/nodata.png";
import { Bars, Circles } from "react-loader-spinner";
import { useFormik } from 'formik';
import * as Yup from "yup";

const Excercise = () => {
    const [pageNo, setPageNo] = useState(1);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [searchData, setSearchData] = useState("");
    const [totalPage, setTotalPage] = useState("1");
    const [excerciseOpen, setExcerciseOpen] = useState(false);
    const [IsDelete, setIsDelete] = useState(false);
    const [excerciseData, setExcerciseData] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const [loader, setLoader] = useState(false);
    const [search] = useDebounce(searchData, 1000);
    const [isLoading, setIsLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedExercise, setSelectedExercise] = useState(null);
    const [selectedExerciseId, setSelectedExerciseId] = useState(null);
    const scrollRef = useRef(null);
    const navigate = useNavigate();

    const handlExcerciseList = () => {
        setLoader(true);
        let obj = { page: pageNo };

        if (search) {
            obj.search = search;
        }

        allExcerciseList(obj)
            .then((res) => {
                setTotalPage(res?.data?.pagination?.totalPages);
                setLoader(false);
                setExcerciseData(res?.data?.data || []);
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/login");
                } else {
                    toast.error(err?.response?.data?.message);
                }
                setLoader(false);
            });
    };

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const sortedData = [...excerciseData].sort((a, b) => {
        if (!sortColumn) return 0;

        let valueA = a[sortColumn] ?? ""; 
        let valueB = b[sortColumn] ?? ""; 

        if (sortColumn === "id" || sortColumn === "someNumericField") {
            valueA = Number(valueA) || 0;
            valueB = Number(valueB) || 0;
            return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
        }

        if (sortColumn === "exercise") {
            valueA = a.excercise_name?.toLowerCase() || "";
            valueB = b.excercise_name?.toLowerCase() || "";
        } else {
            valueA = valueA.toString().toLowerCase();
            valueB = valueB.toString().toLowerCase();
        }

        return sortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });


    const startDragging = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
        document.body.style.userSelect = "none";
    };

    const stopDragging = () => {
        setIsDragging(false);
        document.body.style.userSelect = "";
    };

    const onDragging = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 2;
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleSearchChange = (e) => {
        setSearchData(e.target.value);
        setPageNo(1);
    };

    useEffect(() => {
        handlExcerciseList();
    }, [pageNo, search]);

    const renderPaginationButtonss = () => {
        const maxPagesToShow = 3;
        const buttons = [];
        const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={
                        i === pageNo
                            ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
                            : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
                    }
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPage) {
            setPageNo(page);
        }
    };

    const columns = [
        { key: "id", label: "ID" },
        { key: "excercise_name", label: "EXERCISE" },
    ];

    const validationSchema = Yup.object({
        exercise_name: Yup.string().required("Exercise name is required"),
    });

    const handleOpenModal = (exercise = null) => {
        if (exercise) {
            setEditMode(true);
            setSelectedExercise(exercise);
            formik.setValues({ exercise_name: exercise.excercise_name });
        } else {
            setEditMode(false);
            setSelectedExercise(null);
            formik.resetForm();
        }
        setExcerciseOpen(true);
    };

    const handleOpenDeleteModal = (exerciseId) => {
        setSelectedExerciseId(exerciseId);
        setIsDelete(true);
    };

    const formik = useFormik({
        initialValues: {
            exercise_name: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            setIsLoading(true);
            const obj = { excercise_name: values.exercise_name.trim() };

            if (editMode && selectedExercise) {
                obj.excercise_id = selectedExercise.id;

                editExcercise(obj)
                    .then((res) => {
                        if (res?.status === 200) {
                            toast.success(res?.data?.message);
                            setExcerciseData((prev) =>
                                prev.map((item) =>
                                    item.excercise_id === obj.excercise_id ? res?.data : item
                                )
                            );
                            handlExcerciseList();
                            closeModal(resetForm);
                        }
                    })
                    .catch((err) => {
                        console.error("Error editing exercise:", err);
                        toast.error(err?.response?.data?.message || "Something went wrong!");
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            } else {
                addExcercise(obj)
                    .then((res) => {
                        if (res?.status === 200) {
                            toast.success(res?.data?.message);
                            setExcerciseData((prev) => [...prev, res?.data]);
                            handlExcerciseList();
                            closeModal(resetForm);
                        }
                    })
                    .catch((err) => {
                        console.error("Error adding exercise:", err);
                        toast.error(err?.response?.data?.message || "Something went wrong!");
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        },
    });

    const closeModal = (resetForm) => {
        setExcerciseOpen(false);
        resetForm();
        setEditMode(false);
        setSelectedExercise(null);
    };

    const handleDeleteExercise = () => {
        if (!selectedExerciseId) return;

        setIsLoading(true);

        deleteExcercise({ excercise_id: selectedExerciseId })
            .then((res) => {
                if (res?.status === 200) {
                    toast.success(res?.data?.message);

                    setExcerciseData((prev) => prev.filter(item => item.excercise_id !== selectedExerciseId));
                    handlExcerciseList();
                    setIsDelete(false);
                    setSelectedExerciseId(null);
                }
            })
            .catch((err) => {
                console.error("Error deleting exercise:", err);
                toast.error(err?.response?.data?.message || "Something went wrong!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    return (
        <>
            <div className="grid grid-cols-12 md:m-4 m-1 fontNew">
                <div className="col-span-12 duration-300 cursor-pointer">
                    <div className="flex items-center justify-end gap-4 mb-4 ">
                        <div className="flex xl:w-70 sm:w-52 w-full h-10 px-4 sm:mb-0 mb-3 rounded-[8px] bg-white items-center">
                            <input
                                type="text"
                                required
                                className="bg-transparent  sm:w-70 w-full border-none outline-none h-10 text-sm fontNew"
                                placeholder="Search..."
                                name="search_text"
                                value={searchData}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div>
                            <button
                                className="bg-primary sm:w-36 w-30 text-sm rounded-xl h-10 sm:mx-3 mx-2 text-white"
                                onClick={() => handleOpenModal()}
                            >
                                Add Excercise
                            </button>
                        </div>
                    </div>
                </div>
                {loader ? (
                    <div className="flex justify-center items-center col-span-12 h-[70vh]">
                        <Bars
                            height="35"
                            width="35"
                            color="#FF4433"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                        />
                    </div>
                ) : (
                    <>
                        {excerciseData.length === 0 ? (
                            <div className="col-span-12 h-[50vh] justify-center flex items-center">
                                <img src={nodata} className="w-28" alt="No data" />
                            </div>
                        ) : (
                            <>
                                <div className="col-span-12 ">
                                    <div
                                        className="w-full overflow-auto"
                                        onMouseDown={startDragging}
                                        onMouseLeave={stopDragging}
                                        onMouseUp={stopDragging}
                                        onMouseMove={onDragging}
                                        ref={scrollRef}
                                    >
                                        <table className="w-full border-separate border-spacing-y-3">
                                            <thead>
                                                <tr className="bg-white">
                                                    {columns.map(({ key, label }) => (
                                                        <th
                                                            key={key}
                                                            className={`py-4 px-2 text-base font-medium whitespace-nowrap text-start cursor-pointer ${key === "id" && "pl-4"}`}
                                                            onClick={() => handleSort(key)}
                                                        >
                                                            {label}
                                                            <span className="inline-block ml-1">
                                                                {sortColumn === key ? (
                                                                    sortOrder === "asc" ? <FaSortDown className="inline-block" /> : <FaCaretUp className="inline-block" />
                                                                ) : (
                                                                    <FaSort className="inline-block text-gray-400" />
                                                                )}
                                                            </span>
                                                        </th>
                                                    ))}
                                                    <th className="py-4 px-5 text-base font-medium whitespace-nowrap text-center">
                                                        ACTION
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sortedData.map((item, index) => {
                                                    return (
                                                        <tr key={index} className="font-medium bg-white">
                                                            <td className="text-start px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                                                    <p className="text-base">{item?.id || "-"}</p>
                                                                </div>
                                                            </td>
                                                            <td className="text-start px-2 py-3 first:rounded-l-lg last:rounded-r-lg w-[30%]">
                                                                <div className="lg:whitespace-normal whitespace-nowrap lg:break-all break-normal">
                                                                    <p className="text-base line-clamp-1">{item.excercise_name || "-"}</p>
                                                                </div>
                                                            </td>
                                                            <td className="text-start px-2 py-3 first:rounded-l-lg last:rounded-r-lg">
                                                                <div className="flex items-center justify-center gap-3">
                                                                    <div
                                                                        className="cursor-pointer bg-[#5570F129] w-9 h-9 rounded-full flex items-center justify-center"
                                                                        onClick={() => handleOpenModal(item)}
                                                                    >
                                                                        <Pencil color='#5570F1' size={17} />
                                                                    </div>
                                                                    <div
                                                                        className="cursor-pointer"
                                                                        onClick={() => handleOpenDeleteModal(item.id)}
                                                                    >
                                                                        <img
                                                                            src={deletes}
                                                                            className="lg:w-9 w-8"
                                                                            alt="Delete"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                                    <div className="flex items-center cursor-pointer">
                                        <p
                                            onClick={() => handlePageChange(pageNo - 1)}
                                            disabled={pageNo === 1}
                                        >
                                            Previous
                                        </p>
                                        <div className="flex items-center mx-6">
                                            {renderPaginationButtonss()}
                                        </div>
                                        <p
                                            onClick={() => handlePageChange(pageNo + 1)}
                                            disabled={pageNo === totalPage}
                                        >
                                            Next
                                        </p>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>

            <Dialog open={excerciseOpen} onClose={() => closeModal(formik.resetForm)} size="2xl">
                <Dialog.Panel>
                    <Dialog.Description className="rounded-none border-2 border-white">
                        <div className="flex justify-center my-4 sm:px-16 px-4 fontNew">
                            <div>
                                <h4 className="text-xl text-center font-semibold text-black mt-6">
                                    {editMode ? "Edit Exercise" : "Add Exercise"}
                                </h4>

                                <form onSubmit={formik.handleSubmit}>
                                    <div className="my-3">
                                        <label className="text-base">Exercise:</label>
                                        <input
                                            type="text"
                                            name="exercise_name"
                                            placeholder="Enter the exercise"
                                            value={formik.values.exercise_name}
                                            className={`bg-transparent px-4 rounded-xl border-2 h-[54px] w-full outline-secondary text-base mt-2 ${formik.errors.exercise_name && formik.touched.exercise_name
                                                ? "border-red-500"
                                                : "border-slate-300"
                                                }`}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.exercise_name && formik.touched.exercise_name && (
                                            <div className="text-red-500 text-sm mt-1">{formik.errors.exercise_name}</div>
                                        )}
                                    </div>

                                    <div className="mt-7 flex items-center mb-5">
                                        <button
                                            className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                                            type="button"
                                            onClick={() => closeModal(formik.resetForm)}
                                        >
                                            Close
                                        </button>

                                        <button
                                            className="bg-primary h-[50px] sm:w-36 w-30 disabled:bg-red-400 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <div className="flex justify-center">
                                                    <Circles width={25} height={25} color="#fff" ariaLabel="circles-loading" />
                                                </div>
                                            ) : (
                                                editMode ? "Update" : "Submit"
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>


            <Dialog open={IsDelete} onClose={() => setIsDelete(false)} size="md">
                <Dialog.Panel>
                    <Dialog.Description className="rounded-none border-2 border-white">
                        <div className="flex justify-center my-4 sm:px-16 px-5 fontNew">
                            <div>
                                <h4 className="text-xl text-center font-semibold text-black mt-6">
                                    Delete Exercise?
                                </h4>
                                <p className="text-lg text-gray-500 my-3">
                                    Are you sure you want to delete this exercise?
                                </p>
                                <div className="flex items-center justify-center mt-7 mb-10">
                                    <button
                                        type="button"
                                        className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                                        onClick={() => setIsDelete(false)}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        disabled={isLoading}
                                        className="bg-[#ea5f5f] h-[50px] disabled:bg-red-400 sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                                        onClick={handleDeleteExercise}
                                    >
                                        {isLoading ? (
                                            <div className="flex justify-center">
                                                <Circles width={25} height={25} color="#fff" ariaLabel="circles-loading" />
                                            </div>
                                        ) : (
                                            "Delete"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>

        </>
    );
};

export default Excercise;
